import { Table as MuiTable, type TableProps as MuiTableProps } from '@mui/material';

import type { WithoutStyleOverrides } from '../../../types/WithoutStyleOverrides';

type Props = WithoutStyleOverrides<MuiTableProps>;

export function Table(props: Props) {
  return <MuiTable {...props} />;
}

export type { Props as TableProps };
